import { IconClose12, IconSuccess16, IconWarningCircle16, IconWarningSign16 } from '@cian/ui-kit';

import { FC, useEffect } from 'react';
import { ToastContainer, ToastContainerProps, toast } from 'react-toastify';

import styles from './NotificationCenter.css';

export const notification = toast;

let loaded = false;

export const NotificationCenterProvider: FC<ToastContainerProps> = props => {
  useEffect(() => {
    if (!loaded) {
      import('react-toastify/dist/ReactToastify.min.css').then(() => {
        loaded = true;
      });
    }
  }, []);

  return (
    <ToastContainer
      {...props}
      hideProgressBar
      bodyClassName={styles['body-class-name']}
      closeButton={
        <div>
          <IconClose12 />
        </div>
      }
      icon={(iconProps): JSX.Element | true => {
        switch (iconProps.type) {
          case 'success':
            return <IconSuccess16 color="success_100" />;
          case 'error':
            return <IconWarningCircle16 color="error_100" />;
          case 'warning':
            return <IconWarningSign16 color="warning_100" />;
          default:
            return true;
        }
      }}
    />
  );
};
